import { BaseButton, ButtonTypes } from '../types'

export class BaseFlowButtonWithOutput implements BaseButton {
  text!: string
  guid!: string
  type!: ButtonTypes.FlowFormButton | ButtonTypes.RunFlowNode | ButtonTypes.PopupButton | ButtonTypes.RedirectButton
  output!: number | null
}
